export default __webpack_public_path__ + "static/media/person_green.6084f455.svg";